// extracted by mini-css-extract-plugin
export default {"desktopInstructionsText":"BranchNextStepDesktop-module__desktopInstructionsText--Bs45Q"};